export const PRESCRIPTION_ADMINISTRATION_ROUTES = [
  { value: 'oral', labelKey: 'reports.prescriptionRouteOral' },
  { value: 'sublingual', labelKey: 'reports.prescriptionRouteSublingual' },
  { value: 'intravenous_infusion', labelKey: 'reports.prescriptionRouteIntravenousInfusion' },
  { value: 'intravenous_injection', labelKey: 'reports.prescriptionRouteIntravenousInjection' },
  { value: 'intramuscular', labelKey: 'reports.prescriptionRouteIntramuscular' },
  { value: 'subcutaneous', labelKey: 'reports.prescriptionRouteSubcutaneous' },
  { value: 'inhalation', labelKey: 'reports.prescriptionRouteInhalation' },
  { value: 'nebulization', labelKey: 'reports.prescriptionRouteNebulization' },
  { value: 'topical', labelKey: 'reports.prescriptionRouteTopical' },
  { value: 'nasal', labelKey: 'reports.prescriptionRouteNasal' },
  { value: 'ophthalmic', labelKey: 'reports.prescriptionRouteOphthalmic' },
  { value: 'otic', labelKey: 'reports.prescriptionRouteOtic' },
  { value: 'rectal', labelKey: 'reports.prescriptionRouteRectal' },
  { value: 'vaginal', labelKey: 'reports.prescriptionRouteVaginal' }
];

export const PRESCRIPTION_FREQUENCIES = [
  { value: 'stat', labelKey: 'reports.prescriptionFrequencyStat' },
  { value: 'once', labelKey: 'reports.prescriptionFrequencyOnce' },
  { value: 'qd', labelKey: 'reports.prescriptionFrequencyQd' },
  { value: 'bid', labelKey: 'reports.prescriptionFrequencyBid' },
  { value: 'tid', labelKey: 'reports.prescriptionFrequencyTid' },
  { value: 'qid', labelKey: 'reports.prescriptionFrequencyQid' },
  { value: 'qam', labelKey: 'reports.prescriptionFrequencyQam' },
  { value: 'qhs', labelKey: 'reports.prescriptionFrequencyQhs' },
  { value: 'qod', labelKey: 'reports.prescriptionFrequencyQod' },
  { value: 'q4h', labelKey: 'reports.prescriptionFrequencyQ4h' },
  { value: 'q6h', labelKey: 'reports.prescriptionFrequencyQ6h' },
  { value: 'q8h', labelKey: 'reports.prescriptionFrequencyQ8h' },
  { value: 'weekly', labelKey: 'reports.prescriptionFrequencyWeekly' },
  { value: 'prn', labelKey: 'reports.prescriptionFrequencyPrn' },
  { value: 'as_directed', labelKey: 'reports.prescriptionFrequencyAsDirected' }
];

const getOptionLabel = (options, value, t) => {
  const option = options.find((candidate) => candidate.value === value);
  return option ? t(option.labelKey) : value;
};

export const getPrescriptionRouteLabel = (value, t) => (
  getOptionLabel(PRESCRIPTION_ADMINISTRATION_ROUTES, value, t)
);

export const getPrescriptionFrequencyLabel = (value, t) => (
  getOptionLabel(PRESCRIPTION_FREQUENCIES, value, t)
);
